import { createSelector } from 'reselect';
import { actionTypes } from '../actions';

// Constants (down)

export const moduleName = 'forgotPassword';

// Constants (up)

// Reducer (down)

/**
 *
 * @type {{
 * processing: boolean,
 * error: string,
 * successMessage: string,
 * resettingParams: null | { email: string, token: string },
 * }}
 */
const initialState = {
  processing: false,
  error: '',
  successMessage: '',
  resettingParams: null,
};

export default function reducer(state = initialState, action) {
  const { error, type, payload } = action;

  switch (type) {
    case actionTypes.FORGOT_PASSWORD_POST_REQUEST:
    case actionTypes.FORGOT_PASSWORD_RESET_REQUEST: {
      return {
        ...state,
        processing: true,
        error: initialState.error,
        successMessage: initialState.successMessage,
      };
    }

    case actionTypes.FORGOT_PASSWORD_POST_SUCCESS:
    case actionTypes.FORGOT_PASSWORD_RESET_SUCCESS: {
      const { successMessage } = payload;

      return {
        ...state,
        processing: false,
        error: initialState.error,
        successMessage: successMessage || 'Ready!',
      };
    }

    case actionTypes.FORGOT_PASSWORD_POST_FAILURE: {
      return {
        ...state,
        error: error || 'Cannot request password resetting!',
        processing: false,
        successMessage: initialState.successMessage,
      };
    }

    case actionTypes.FORGOT_PASSWORD_RESET_FAILURE: {
      return {
        ...state,
        error: error || 'Cannot change your password. Please, try again later!',
        processing: false,
        successMessage: initialState.successMessage,
      };
    }

    case actionTypes.FORGOT_PASSWORD_SET_RESETTING_MODE: {
      const { resettingParams } = payload;

      return {
        ...state,
        resettingParams,
        processing: false,
        error: initialState.error,
        successMessage: initialState.successMessage,
      };
    }

    default:
      return state;
  }
}

// Reducer (up)

// Selectors (down)

const stateSelector = (state) => state[moduleName];

export const selectForgotPasswordIsProcessing = createSelector(
  stateSelector,
  (forgotPassword) => forgotPassword.processing,
);

export const selectForgotPasswordError = createSelector(
  stateSelector,
  (forgotPassword) => forgotPassword.error,
);

export const selectForgotPasswordSuccessMessage = createSelector(
  stateSelector,
  (forgotPassword) => forgotPassword.successMessage,
);

export const selectForgotPasswordResettingParams = createSelector(
  stateSelector,
  (forgotPassword) => forgotPassword.resettingParams,
);

export const selectForgotPasswordIsResettingMode = createSelector(
  selectForgotPasswordResettingParams,
  (resettingParams) => !!resettingParams,
);

export const selectForgotPasswordCurrentEmail = createSelector(
  selectForgotPasswordResettingParams,
  (resettingParams) => (resettingParams && resettingParams.email) || '',
);

// Selectors (up)



// WEBPACK FOOTER //
// ./reducers/forgotPassword.js